export default "__VITE_PUBLIC_ASSET__18c8308e__"